import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { ArrowLeft, Activity } from 'lucide-react';
import SignInActivityWidget from '../../components/admin/SignInActivityWidget';
import { useSmartBack } from '../../hooks/useSmartBack';

/**
 * Standalone page wrapper for the Sign-In Activity widget (moved off the Dashboard).
 * Master-admin-only; the widget itself self-hides for lower roles via the 403.
 */
export default function AdminSignInActivityPage() {
  const { token } = useAuth();
  const { back } = useSmartBack('/admin/settings');
  return (
    <div className="min-h-screen bg-zinc-50" data-testid="admin-sign-in-activity-page">
      <header className="bg-white border-b border-zinc-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-3">
          <button onClick={back} className="p-2 hover:bg-zinc-100 rounded-lg" aria-label="Back to settings" data-testid="back-btn">
            <ArrowLeft className="w-4 h-4 text-zinc-600" />
          </button>
          <div className="w-9 h-9 rounded-lg bg-[#F56F05]/10 text-[#F56F05] flex items-center justify-center">
            <Activity className="w-4 h-4" />
          </div>
          <div>
            <h1 className="text-lg font-extrabold text-zinc-900" style={{ fontFamily: 'Outfit, sans-serif' }}>Sign-In Activity</h1>
            <p className="text-xs text-zinc-500">Recent login events, pending invites, dormant users, and failed logins.</p>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <SignInActivityWidget token={token} />
      </main>
    </div>
  );
}
